// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Select__pc_only___28Db4","sp_only":"Select__sp_only___1RJXx","select":"Select__select___17Z8Y","prompt":"Select__prompt___2Rb2N"};